import React, { Component } from 'react';
import Paginator from 'paginator';

import Button from '../Button';

const NUM_PAGES_TO_DISPLAY = 20;

class Pagination extends Component {
  constructor(props) {
    super(props);

    this.renderPages = this.renderPages.bind(this);
  }

  handleButtonClick(pageMod, e) {
    if (typeof this.props.onChange === 'function') {
      let page = this.props.current + pageMod;

      // Make sure that the pagination doesn't try to access
      // pages below 1, and above the total number of pages
      if (page > 0 && page * this.props.perPage <= this.props.total + (this.props.perPage - 1)) {
        this.props.onChange(page);
      }
    }
  }

  handlePageClick(page, e) {
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(page);
    }
  }

  renderPages() {
    let html = [];

    // Setup paginator object with settings
    let paginator = new Paginator(this.props.perPage, NUM_PAGES_TO_DISPLAY);
    let paginationInfo = paginator.build(this.props.total, this.props.current);

    for (let i = paginationInfo.first_page; i <= paginationInfo.last_page; i++) {
      let classes = ['page'];

      if (i === paginationInfo.current_page) {
        classes.push('active');
      }

      let el = (
        <div
          className={classes.join(' ')}
          key={`page-${i}`}
          onClick={i !== paginationInfo.current_page ? this.handlePageClick.bind(this, i) : null}>
          {i}
        </div>
      );

      html.push(el);
    }

    return html;
  }

  render() {
    return (
      <div className="pagination">
        <div className="buttons">
          <div className="button-container">
            <Button
              className="prev"
              color="alpha-teal"
              disabled={this.props.current === 1}
              onClick={this.handleButtonClick.bind(this, -1)}>
              <i className="fa fa-chevron-left" aria-hidden="true"></i>
            </Button>
          </div>
          <div className="pages">
            { this.renderPages() }
          </div>
          <div className="button-container">
            <Button
              className="next"
              color="alpha-teal"
              disabled={this.props.current === Math.ceil(this.props.total / this.props.perPage)}
              onClick={this.handleButtonClick.bind(this, 1)}>
              <i className="fa fa-chevron-right" aria-hidden="true"></i>
            </Button>
          </div>
        </div>
        <div className="info">
          Showing {(this.props.current * this.props.perPage) - this.props.perPage || 1} to {this.props.current * this.props.perPage < this.props.total ? this.props.current * this.props.perPage : this.props.total} of {this.props.total} ({Math.ceil(this.props.total / this.props.perPage)} Pages)
        </div>
      </div>
    );
  }
}

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/Pagination/Pagination.js